module.exports = __webpack_public_path__ + "img/chess_chinesechessred7.35e82b1a.png";